<template>
  <div class="maincont child" id="user_setting">
    <div class="ef--inner">
      <h2>お客さま設定</h2>
      <div class="form" method="post" action>
        <div id="user_setting_form">
          <ul>
            <span class="lt">パスワード</span>
            <li style="padding-left: 10px;">
              <input
                type="button"
                id="passChg"
                class="passChg"
                value="パスワード変更"
                @click="showModal = true"
              />
            </li>

            <span class="lt">デマンド監視設定</span>

            <!----------------------------------------------------------------->

            <li>
              <label for="Agre" style="vertical-align:top;"
                >デマンド目標値</label
              >
              <div style="display:inline-block">
                <input
                  type="text"
                  id="Agre"
                  class="sNum"
                  v-model="info.contract_power"
                  v-validate="'numeric|max:4'"
                  name="contract_power"
                  data-vv-as="デマンド目標値"
                />&nbsp;kW&nbsp;
                <div class="err_message">
                  {{ errors.first("contract_power") }}
                </div>
              </div>
            </li>

            <!------------------------------------------------------------------
              -- 空調機制御無し
              ----------------------------------------------------------------->

            <li v-if="!(getAirConditionerControl == true)">
              <label for="AlertThr" style="vertical-align:top;">警報閾値</label>
              <div style="display:inline-block">
                <input
                  type="text"
                  id="AlertThr"
                  class="sNum"
                  v-model="alarmThreshold"
                  disabled="true"
                  style="background-color:lightgray"
                />&nbsp;kW&nbsp;
                <input
                  type="text"
                  id="AlertPer"
                  class="sNum"
                  v-model="info.alarm_threshold"
                  v-validate="'required|min_value:0|max_value:100|decimal:1|comp_alarm_threshold:'+info.caution_threshold"
                  name="alarm_threshold"
                  data-vv-as="警報閾値"
                />&nbsp;%
                <div class="err_message">
                  {{ errors.first("alarm_threshold") }}
                </div>
              </div>
            </li>

            <li v-if="!(getAirConditionerControl == true)">
              <label for="WarnThr" style="vertical-align:top;">注意閾値</label>
              <div style="display:inline-block">
                <input
                  type="text"
                  id="WarnThr"
                  class="sNum"
                  v-model="cautionThreshold"
                  disabled="true"
                  style="background-color:lightgray"
                />&nbsp;kW&nbsp;
                <input
                  type="text"
                  id="WarnPer"
                  class="sNum"
                  v-model="info.caution_threshold"
                  v-validate="'required|min_value:0|max_value:100|decimal:1'"
                  name="caution_threshold"
                  data-vv-as="注意閾値"
                />&nbsp;%
                <div class="err_message">
                  {{ errors.first("caution_threshold") }}
                </div>
              </div>
            </li>

            <!------------------------------------------------------------------
              -- 空調機制御有り
              ----------------------------------------------------------------->

            <li v-if="getAirConditionerControl == true">
              <label for="CautionPower" style="vertical-align:top;">注意電力</label>
              <div style="display:inline-block">
                <input
                  type="text"
                  id="CautionPower"
                  class="sNum"
                  v-model="info.caution_power"
                  v-validate="'required|numeric|min_value:0|max_value:9999'"
                  name="caution_power"
                  data-vv-as="注意電力"
                />&nbsp;kW
                <div class="err_message">
                  {{ errors.first("caution_power") }}
                </div>
              </div>
            </li>

            <li v-if="getAirConditionerControl == true">
              <label for="LimitPower" style="vertical-align:top;">限界電力</label>
              <div style="display:inline-block">
                <input
                  type="text"
                  id="LimitPower"
                  class="sNum"
                  v-model="info.limit_power"
                  v-validate="'required|numeric|min_value:1|max_value:9999|comp_limit_power:'+info.caution_power"
                  name="limit_power"
                  data-vv-as="限界電力"
                />&nbsp;kW
                <div class="err_message">
                  {{ errors.first("limit_power") }}
                </div>
              </div>
            </li>

            <li v-if="getAirConditionerControl == true">
              <label for="margin" style="vertical-align:top;">余裕率</label>
              <div style="display:inline-block">
                <input
                  type="text"
                  id="margin"
                  class="sNum"
                  disabled="disabled"
                  style="background-color: lightgray"
                  v-model="info.margin"
                  v-validate="'required|numeric|min_value:1|max_value:99'"
                  name="margin"
                  data-vv-as="余裕率"
                />&nbsp;%
                <div class="err_message">
                  {{ errors.first("margin") }}
                </div>
              </div>
            </li>

            <!----------------------------------------------------------------->

            <li>
              <label for="detail_setting" style="vertical-align:top;"
                >月別閾値</label
              >
              <div style="display:inline-block">
                <input
                  type="button"
                  id="SettingDemand"
                  class="settingDemand"
                  value="月別閾値設定"
                  @click="$router.push(`/setting_demand`)"
                />
              </div>
            </li>

            <span class="lt">デマンド警報通知先アドレス</span>
            <li>
              <div style="display: inline-block">
                <table class="address-list" _fixedhead="rows:1;cols:0;">
                  <thead>
                    <tr>
                      <th>通知先アドレス</th>
                      <th>デマンド注意通知</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          id="mail1"
                          class="stxt"
                          v-model="info.alert_send_address_1"
                          v-validate="'email|max:64'"
                          name="email1"
                          data-vv-as="入力値"
                        />
                        <div class="err_message">{{ errors.first("email1") }}</div>
                      </td>
                      <td>
                        <div class="selectpulllist">
                          <select v-model="info.customer_caution_send_flg_1">
                            <option
                              v-for="(option, index) in customerCautionOptions"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option
                            >
                          </select>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="text"
                          id="mail2"
                          class="stxt"
                          v-model="info.alert_send_address_2"
                          v-validate="'email|max:64'"
                          name="email2"
                          data-vv-as="入力値"
                        />
                        <div class="err_message">{{ errors.first("email2") }}</div>
                      </td>
                      <td>
                        <div class="selectpulllist">
                          <select v-model="info.customer_caution_send_flg_2">
                            <option
                              v-for="(option, index) in customerCautionOptions"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option
                            >
                          </select>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="text"
                          id="mail3"
                          class="stxt"
                          v-model="info.alert_send_address_3"
                          v-validate="'email|max:64'"
                          name="email3"
                          data-vv-as="入力値"
                        />
                        <div class="err_message">{{ errors.first("email3") }}</div>
                      </td>
                      <td>
                        <div class="selectpulllist">
                          <select v-model="info.customer_caution_send_flg_3">
                            <option
                              v-for="(option, index) in customerCautionOptions"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option
                            >
                          </select>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="text"
                          id="mail4"
                          class="stxt"
                          v-model="info.alert_send_address_4"
                          v-validate="'email|max:64'"
                          name="email4"
                          data-vv-as="入力値"
                        />
                        <div class="err_message">{{ errors.first("email4") }}</div>
                      </td>
                      <td>
                        <div class="selectpulllist">
                          <select v-model="info.customer_caution_send_flg_4">
                            <option
                              v-for="(option, index) in customerCautionOptions"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option
                            >
                          </select>
                        </div>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <input
                          type="text"
                          id="mail5"
                          class="stxt"
                          v-model="info.alert_send_address_5"
                          v-validate="'email|max:64'"
                          name="email5"
                          data-vv-as="入力値"
                        />
                        <div class="err_message">{{ errors.first("email5") }}</div>
                      </td>
                      <td>
                        <div class="selectpulllist">
                          <select v-model="info.customer_caution_send_flg_5">
                            <option
                              v-for="(option, index) in customerCautionOptions"
                              v-bind:value="option.value"
                              v-bind:key="index"
                              >{{ option.text }}</option
                            >
                          </select>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>

          <div id="submit_area">
            <input
              type="button"
              id="submit"
              class="submit"
              value="登録"
              @click="onSubmmit"
            />
            <input
              type="button"
              id="cancel"
              class="cancel"
              value="キャンセル"
              @click="$router.go(-1)"
            />
          </div>
          <div style="width: 100%;" v-if="info.alert_call_mail_address">
            <span style="float:right;"><a href="javascript:void(0);" @click="onAlertCall">アラートコールの設定はこちら</a></span>
          </div>
        </div>
      </div>
    </div>
    <password-dialog
      @close="showModal = false"
      v-if="showModal"
      :account="this.$store.state.childID"
    ></password-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import PasswordDialog from "../components/PasswordDialog";

export default {
  name: "setting",
  computed: {
    alarmThreshold: {
      get: function() {
        console.log("getter");
        const val =
          parseFloat(this.info.contract_power) *
          (parseFloat(this.info.alarm_threshold) / 100.0);
        if (isNaN(val)) {
          return "";
        }
        console.log(val);
        let str = String(val.toFixed(1));
        if (str.indexOf(".0") != -1) {
          str = str.split(".")[0];
        }
        return str;
      },
      set: function(newVal) {
        console.log("setter");
        console.log(newVal);
        this.info.alarm_threshold = (
          (newVal / this.info.contract_power) *
          100
        ).toFixed(1);
        console.log((newVal / this.info.contract_power) *100);
      }
    },
    cautionThreshold: {
      get: function() {
        console.log("---getter");
        const val =
          parseFloat(this.info.contract_power) *
          (parseFloat(this.info.caution_threshold) / 100.0);
        if (isNaN(val)) {
          return "";
        }

        let str = String(val.toFixed(1));
        if (str.indexOf(".0") != -1) {
          str = str.split(".")[0];
        }
        return str;
      },
      set: function(newVal) {
        console.log("----setter");
        console.log(newVal);
        this.info.caution_threshold = (
          (newVal / this.info.contract_power) *
          100
        ).toFixed(1);
      }
    },
    getAirConditionerControl: function() {
      let ret = false;
      let value = this.info.measure_instrument;
      if (value == null) {
        value = this.$store.state.childInfo.power_info['measure_instrument'];
      }
      if ((value > 1) && (this.info.air_conditioner_control == true) && (this.info.air_conditioner_id_count > 0)) {
        ret = true;
      }
      return ret;
    }
  },
  components: {
    PasswordDialog
  },
  data: function() {
    return {
      showModal: false,
      info: {
        alarm_threshold: 0,
        alert_send_address_1: "",
        alert_send_address_2: "",
        alert_send_address_3: "",
        alert_send_address_4: "",
        alert_send_address_5: "",
        customer_caution_send_flg_1: "true",
        customer_caution_send_flg_2: "true",
        customer_caution_send_flg_3: "true",
        customer_caution_send_flg_4: "true",
        customer_caution_send_flg_5: "true",
        caution_threshold: 0,
        contract_power: 0,
        alert_call_mail_address: "",
        measure_instrument: null,
        air_conditioner_control: null,
        air_conditioner_id_count: 0,
        caution_power: null,
        limit_power: null,
        margin: null
      },
      customerCautionOptions: [
        { text: "要", value: "true" },
        { text: "不要", value: "false" }
      ]
    };
  },

  methods: {
    onSubmmit: function() {
      const childID = this.$store.state.childID;
      console.log(`onSubmmit=${childID}`);
      this.$validator.validateAll().then(result => {
        console.log(result);
        if (result) {
          if (this.info.limit_power == null) {
            this.info.limit_power = 0;
          }
          if (this.info.margin == null) {
            this.info.margin = 90;
          }
          //エラーがなかった時の処理を下に記述
          this.updateInformation(this.info);
        }
      });
      // this.updateInformation(this.info);
    },
    getInformation() {
      const self = this;
      const childID = this.$store.state.childID;
      this.$axios
        .get(`/srv/api/information/${childID}`, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.info = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    updateInformation: function(param) {
      const self = this;
      const childID = this.$store.state.childID;
      console.log(`updateInformation=${childID}`);
      console.log(param);

      this.$axios
        .put(`/srv/api/information/${childID}`, param, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          if (response.data.status == "failure") {
            console.warn("daytoday failure");
            alert("登録できませんでした。");
          } else {
            self.$router.go(-1);
          }
        })
        .catch(error => {
          console.log(error);
          alert("登録できませんでした");
        });
    },
    onAlertCall: function() {
      window.open("https://service.cuecall.jp/NSW/", '_blank');
    },
    setValidate: function() {
      let caution_threshold_validate = {
        required: () => '注意閾値は必須項目です',
        decimal: () => '注意閾値の小数点は 1桁 までです',
        min_value: () => '注意閾値の入力範囲は 0 ～ 100 です',
        max_value: () => '注意閾値の入力範囲は 0 ～ 100 です'
      };
      let alarm_threshold_validate = {
        required: () => '警報閾値は必須項目です',
        decimal: () => '警報閾値の小数点は 1桁 までです',
        min_value: () => '警報閾値の入力範囲は 0 ～ 100 です',
        max_value: () => '警報閾値の入力範囲は 0 ～ 100 です'
      };
      let caution_power_validate = {
        required: () => '注意電力は必須項目です',
        numeric: () => '注意電力の入力範囲は 0 ～ 9999 です',
        min_value: () => '注意電力の入力範囲は 0 ～ 9999です',
        max_value: () => '注意電力の入力範囲は 0 ～ 9999です'
      };
      let limit_power_validate = {
        required: () => '限界電力は必須項目です',
        numeric: () => '限界電力の入力範囲は 1 ～ 9999 です',
        min_value: () => '限界電力の入力範囲は 1 ～ 9999 です',
        max_value: () => '限界電力の入力範囲は 1 ～ 9999 です'
      };
      let margin_validate = {
        required: () => '余裕率は必須項目です',
        numeric: () => '余裕率の入力範囲は 1 ～ 99 です',
        min_value: () =>  '余裕率の入力範囲は 1 ～99 です。',
        max_value: () => '余裕率の入力範囲は 1 ～ 99 です。'
      };

      let dict = { custom: {} };
      dict.custom["caution_threshold"] = caution_threshold_validate;
      dict.custom["alarm_threshold"] = alarm_threshold_validate;
      dict.custom["caution_power"] = caution_power_validate;
      dict.custom["limit_power"] = limit_power_validate;
      this.$validator.localize('ja', dict);

      this.$validator.extend(
        "comp_alarm_threshold",
        {
          params: ['caution_threshold'],
          getMessage: field => `警報閾値は注意閾値以上の値のみ入力可能です`,
          validate (alarm_threshold, [caution_threshold]) {
            if (parseInt(caution_threshold) > parseInt(alarm_threshold)) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );
      this.$validator.extend(
        "comp_limit_power",
        {
          params: ['caution_power'],
          getMessage: field => `限界電力は注意電力より大きい値のみ入力可能です`,
          validate (limit_power, [caution_power]) {
            if (parseInt(caution_power) >= parseInt(limit_power)) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );
    }
  },
  mounted: function() {
    console.log("----mounted");

    this.setValidate();
    this.getInformation();
  }
};
</script>

